import Vue from "vue";
import Router2 from "vue-router";
import routeRes from "./mapping";
import browser from "../utils/browser";
import dsbridge from "dsbridge";
import Log from "../utils/log";
import { AppOperate } from "../utils/appfunc";
import store from "../store";
// import { Dialog } from 'vant'
import wx from "weixin-js-sdk";

const queryParamConvert = function(param, key, encode) {
  if (param === null) return "";
  var paramStr = "";
  var t = typeof param;
  if (t === "string" || t === "number" || t === "boolean") {
    paramStr +=
      "&" +
      key +
      "=" +
      (encode == null || encode ? encodeURIComponent(param) : param);
  } else {
    for (var i in param) {
      var k =
        key == null
          ? i
          : key + (param instanceof Array ? "[" + i + "]" : "." + i);
      paramStr += queryParamConvert(param[i], k, encode);
    }
  }
  return paramStr;
};
class Router extends Router2 {
  constructor(props) {
    // eslint-disable-line
    console.log("props", props);
    super(props);
  }
  goto(location) {
    console.log("this", this);
    let router = this;

    let viewRes = router.options.routes.filter(item => {
      return item.path === location.path;
    });

    if (viewRes.length === 0) {
      Log.info("Router.prototype.goto:View not found", location);
      alert("View not found");
      return;
    }

    viewRes = viewRes[0];
    if (
      viewRes.mate !== undefined &&
      viewRes.mate.nativeUri !== null &&
      browser.versions.tui
    ) {
      dsbridge.call("Navigator.navigate", {
        route: viewRes.mate.nativeUri,
        extra: location.query === null ? "" : location.query,
        navigateType: "present"
      });
      return;
    }
    if (browser.versions.tui) {
      let h5QueryUrl = viewRes.path;
      if (location.query) {
        h5QueryUrl = h5QueryUrl + "?" + queryParamConvert(location.query);
      }
      dsbridge.call("Navigator.navigate", {
        route: "H5PageInnerRoute",
        config: {
          navBarHidden: 0,
          urlString: h5QueryUrl,
          title: viewRes.name,
          requireComponents: "Navigator,Operate,LocalInfo,UpdateLocalInfo"
        }
      });
      return;
    } else {
      if (browser.versions.weChat) {
        wx.miniProgram.getEnv(res => {
          if (res.miniprogram === true) {
            // alert(location.path)
            switch (location.path) {
              case "/index":
                if (
                  JSON.stringify(location.query) === "{}" ||
                  !location.query
                ) {
                  wx.miniProgram.reLaunch({
                    url: `/pages/index/index`
                  });
                } else {
                  wx.miniProgram.reLaunch({
                    url: `/pages/index/index?query=${JSON.stringify(
                      location.query
                    )}`
                  });
                }
                break;
              case "/":
                if (
                  JSON.stringify(location.query) === "{}" ||
                  !location.query
                ) {
                  wx.miniProgram.reLaunch({
                    url: `/pages/index/index`
                  });
                } else {
                  wx.miniProgram.reLaunch({
                    url: `/pages/index/index?query=${JSON.stringify(
                      location.query
                    )}`
                  });
                }
                break;
              case "/register/choose":
                if (JSON.stringify(AppOperate.getLoginUserData()) === "{}") {
                  router.goto({
                    path: "/login",
                    query: {
                      redirectFrom: JSON.stringify(
                        Object.assign(
                          { originalPath: location.path },
                          location.query
                        )
                      )
                    }
                  });
                } else {
                  wx.miniProgram.navigateTo({
                    url: `/pages/webview/webview?url=${JSON.stringify(
                      location
                    )}`
                  });
                }
                break;
              default:
                wx.miniProgram.navigateTo({
                  url: `/pages/webview/webview?url=${JSON.stringify(location)}`
                });
                break;
            }
          } else {
            router.push(location);
          }
        });
        return;
      }
    }
    router.push(location);
  }
  replaceto(location) {
    if (browser.versions.tui) {
      router.replace(location);
    } else if (browser.versions.weChat) {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram === true) {
          // alert(location)
          switch (location.path) {
            // case '/index/user':
            //   wx.miniProgram.navigateTo({
            //     url: `/pages/user/user`
            //   })
            //   break
            case "/index":
              if (JSON.stringify(location.query) === "{}" || !location.query) {
                wx.miniProgram.reLaunch({
                  url: `/pages/index/index`
                });
              } else {
                wx.miniProgram.reLaunch({
                  url: `/pages/index/index?query=${JSON.stringify(
                    location.query
                  )}`
                });
              }
              break;
            case "/":
              if (JSON.stringify(location.query) === "{}" || !location.query) {
                wx.miniProgram.reLaunch({
                  url: `/pages/index/index`
                });
              } else {
                wx.miniProgram.reLaunch({
                  url: `/pages/index/index?query=${JSON.stringify(
                    location.query
                  )}`
                });
              }
              break;
            default:
              wx.miniProgram.redirectTo({
                url: `/pages/webview/webview?url=${JSON.stringify(location)}`
              });
              break;
          }
        } else {
          router.replace(location);
        }
      });
    } else {
      router.replace(location);
    }
  }
  // 底部跳转
  navigateTo(location) {
    // console.log('location', location)
    if (browser.versions.tui) {
      router.push(location);
    }
    if (browser.versions.weChat) {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram === true) {
          // alert(location)
          switch (location.path) {
            case "/index":
              wx.miniProgram.reLaunch({
                url: `/pages/index/index`
              });
              break;
            case "/":
              wx.miniProgram.reLaunch({
                url: `/pages/index/index`
              });
              break;
            case "/register/choose":
              if (JSON.stringify(AppOperate.getLoginUserData()) === "{}") {
                router.goto({
                  path: "/login",
                  query: {
                    redirectFrom: JSON.stringify(
                      Object.assign(
                        { originalPath: location.path },
                        location.query
                      )
                    )
                  }
                });
              } else {
                wx.miniProgram.reLaunch({
                  url: `/pages/index/index?url=${JSON.stringify(location)}`
                });
              }
              break;
            default:
              wx.miniProgram.redirectTo({
                url: `/pages/index/index?url=${JSON.stringify(location)}`
              });
              break;
          }
        } else {
          router.replace(location);
        }
      });
    } else {
      router.replace(location);
    }
  }

  // 返回上一个界面
  goBack() {
    if (browser.versions.tui) {
      //公司内核
      dsbridge.call("Navigator.pop", { route: "ToPreviousPage" });
    } else if (browser.versions.weChat) {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram === true) {
          //小程序
          wx.miniProgram.navigateBack({ delta: 1 });
        } else {
          //微信浏览器
            console.log("location---", location);
            router.replace(location);
        }
      });
      return;
    }
    //H5
    window.history.go(-1);
  }

  // 返回最早界面
  goEarliest() {
    if (browser.versions.tui) {
      dsbridge.call("Navigator.pop", { route: "ToRootPage" });
    }
  }
}
Vue.use(Router);
let isKeepAlive = [];
let routeConfigs = [];
routeRes.forEach(item => {
  if (item.redirect) {
    routeConfigs.push({
      path: item.path,
      redirect: item.redirect,
      meta: {
        whiteList: item.whiteList
      }
    });
  } else {
    routeConfigs.push({
      path: item.path,
      children: item.children,
      meta: {
        name: item.name,
        keepAlive: isKeepAlive.indexOf(item.path) !== -1,
        whiteList: item.whiteList
      },
      component: resolve => require(["../views" + item.h5Uri + ".vue"], resolve)
    });
  }
});

let router = new Router({
  routes: [...routeConfigs],
  mode: "history" // 去#
});

router.beforeEach((to, from, next) => {
  let whiteList = ["/", "/index", "/login"];
  //对进入home页面处理
  if (!!window.HOSPITAL_CODE && to.path === "/index") {
    router.goto({
      path: "/hospital/index",
      query: {
        hospitalCode: window.HOSPITAL_CODE,
        hospitalName: window.HOSPITAL_NAME
      }
    });
  }

  if (!whiteList.includes(to.path) && !to.meta.whiteList) {
    if (JSON.stringify(AppOperate.getLoginUserData()) === "{}") {
      // Dialog({ message: '请登录后使用！', showCancelButton: true, showConfirmButton: true }).then(() => {
      if (browser.versions.tui) {
        // if (to.path === '/index/message' || (to.path === '/register/choose' && to.query.reg === '2' && to.query.path === '/index/record')) {
        if (to.path === "/index/message") {
          router.goto({
            path: "/login",
            query: {
              redirectFrom: JSON.stringify(
                Object.assign({ originalPath: to.path }, to.query)
              )
            }
          });
        } else {
          next({
            path: "/login",
            query: {
              redirectFrom: JSON.stringify(
                Object.assign({ originalPath: to.path }, to.query)
              )
            }
          });
        }
      } else if (browser.versions.weChat) {
        wx.miniProgram.getEnv(res => {
          if (res.miniprogram === true) {
            wx.miniProgram.redirectTo({
              url: `/pages/webview/webview?url={"path":"/login"}`
            });
            // console.log(to, to.meta.whiteList)
          } else {
            next({
              path: "/login",
              query: {
                redirectFrom: JSON.stringify(
                  Object.assign({ originalPath: to.path }, to.query)
                )
              }
            });
          }
        });
      } else {
        next({
          path: "/login",
          query: {
            redirectFrom: JSON.stringify(
              Object.assign({ originalPath: to.path }, to.query)
            )
          }
        });
      }
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js